module.exports = __webpack_public_path__ + "media/images/athletes/3424-fd3f536f714ce8e1cce946dc8ae6f121.png";